import { type FC } from 'react';

import type { Data } from '@/components/charts/types';

interface ModelLegendProps {
  data: Array<Data>;
}

const ModelLegend: FC<ModelLegendProps> = ({ data }) => (
  <div className='flex flex-wrap gap-4 mt-4'>
    {data.map((item) => (
      <div
        key={item.id}
        className='flex items-center gap-2'>
        <div
          className='w-3 h-3 rounded-sm'
          style={{ backgroundColor: item.fill }}
        />
        <span className='text-sm text-muted-foreground'>
          {item.model ?? item.id}
        </span>
      </div>
    ))}
  </div>
);

export default ModelLegend;
